import { FunctionComponent } from "react";

import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

/**
 * One icon action at the end of an admin Companies row (top-up, licences, edit, delete).
 *
 * A real button with a label: the previous `Box sx` clickables had no accessible name, so a
 * tester — or a Playwright run — could not tell the four identical grey icons apart (PREC-4063).
 */
export const RowActionIcon: FunctionComponent<{
	icon: IconDefinition;
	label: string;
	onClick: () => void;
	testId?: string;
}> = ({ icon, label, onClick, testId }) => (
	<button
		aria-label={label}
		className="cursor-pointer text-text-meta transition-colors duration-200 hover:text-brand-light"
		data-test={testId}
		title={label}
		type="button"
		onClick={onClick}
	>
		<Icon icon={icon} size="xl" />
	</button>
);
